export const selectAllMessagesCommand = "Dbb";
export default {selectAllMessagesCommand};